import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const ImportExportTrend = ({ 
  data: customData,
  labels: customLabels,
  height = 400,
  title = '',
  showLegend = true,
  interactive = true,
  onDataPointClick
}) => {
  // Default data if none provided
  const defaultData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Import',
        data: [118.2, 112.5, 124.8, 120.5, 125.8, 127.43],
        borderColor: '#4da6ff',
        backgroundColor: 'rgba(77, 166, 255, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Export',
        data: [56.8, 52.9, 55.1, 54.2, 55.9, 58.0],
        borderColor: '#4cd964',
        backgroundColor: 'rgba(76, 217, 100, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      }
    ]
  };

  const chartData = customData || defaultData;
  
  // Override labels if provided
  if (customLabels && chartData.labels) {
    chartData.labels = customLabels;
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: interactive ? (event, elements) => {
      if (elements.length > 0 && onDataPointClick) {
        const element = elements[0];
        const datasetIndex = element.datasetIndex;
        const index = element.index;
        const dataset = chartData.datasets[datasetIndex];
        const value = dataset.data[index];
        const label = chartData.labels[index];
        const datasetLabel = dataset.label;
        
        onDataPointClick({
          label,
          value,
          datasetLabel,
          datasetIndex,
          index
        });
      }
    } : undefined,
    scales: {
      y: {
        title: {
          display: true,
          text: 'Thousand Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          callback: function(value) {
            return value.toFixed(1) + 'K';
          }
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
        display: showLegend
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.dataset.label || '';
            const value = context.parsed.y;
            return `${label}: ${value.toFixed(2)}K Tons`;
          },
          title: function(tooltipItems) {
            return `Month: ${tooltipItems[0].label}`;
          }
        }
      },
      title: {
        display: !!title,
        text: title,
        font: {
          size: 16
        },
        padding: {
          top: 10,
          bottom: 30
        }
      }
    },
    interaction: {
      intersect: false,
      mode: 'index'
    },
    elements: {
      point: {
        radius: interactive ? 4 : 0,
        hoverRadius: 6
      }
    }
  };

  return (
    <div style={{ height: `${height}px` }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default ImportExportTrend;